function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var Slip = require('saito-js/lib/slip')["default"];
var _require = require('./response'),
  success = _require.success,
  failure = _require.failure,
  requestParams = _require.requestParams;
var _require2 = require('../utxo-key'),
  normalizeUtxoKeyHex = _require2.normalizeUtxoKeyHex,
  isUtxoKeyHex = _require2.isUtxoKeyHex,
  parseUtxoKeyHex = _require2.parseUtxoKeyHex;
function slipField(slip, camel, snake) {
  if (!slip) {
    return null;
  }
  if (slip[camel] != null && slip[camel] !== '') {
    return slip[camel];
  }
  if (slip[snake] != null && slip[snake] !== '') {
    return slip[snake];
  }
  return null;
}
function keysMatch(left, right) {
  return normalizeUtxoKeyHex(left) === normalizeUtxoKeyHex(right);
}
function outputMatchesParsed(output, parsed) {
  if (!output || !parsed) {
    return false;
  }
  var outputKey = slipField(output, 'utxoKey', 'utxo_key');
  if (outputKey && keysMatch(outputKey, parsed.utxokey)) {
    return true;
  }
  var blockId = slipField(output, 'blockId', 'block_id');
  var txOrdinal = slipField(output, 'txOrdinal', 'tx_ordinal');
  var slipIndex = slipField(output, 'index', 'slip_index');
  var amount = slipField(output, 'amount', 'amount');
  var type = slipField(output, 'type', 'slip_type');
  try {
    return BigInt(blockId !== null && blockId !== void 0 ? blockId : -1) === parsed.blockId && BigInt(txOrdinal !== null && txOrdinal !== void 0 ? txOrdinal : -1) === parsed.txOrdinal && Number(slipIndex) === parsed.slipIndex && BigInt(amount !== null && amount !== void 0 ? amount : -1) === parsed.amount && Number(type) === parsed.slipType;
  } catch (err) {
    return false;
  }
}
function creatingOutputExists(_x, _x2) {
  return _creatingOutputExists.apply(this, arguments);
}
function _creatingOutputExists() {
  _creatingOutputExists = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, parsed) {
    var block, transactions, txIndex, tx, outputs, output, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(!parsed || parsed.blockId <= 0n)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, false);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return app.core.blockchain.getBlock(BigInt(parsed.blockId.toString()), true);
        case 2:
          block = _context.v;
          if (block) {
            _context.n = 3;
            break;
          }
          return _context.a(2, false);
        case 3:
          transactions = block.transactions || [];
          txIndex = Number(parsed.txOrdinal);
          if (!(!Number.isFinite(txIndex) || txIndex < 0 || txIndex >= transactions.length)) {
            _context.n = 4;
            break;
          }
          return _context.a(2, false);
        case 4:
          tx = transactions[txIndex];
          outputs = (tx === null || tx === void 0 ? void 0 : tx.to) || [];
          if (typeof (tx === null || tx === void 0 ? void 0 : tx.toJson) === 'function') {
            try {
              outputs = tx.toJson().to || outputs;
            } catch (err) {
              // keep wrapper slips
            }
          }
          output = outputs[parsed.slipIndex];
          return _context.a(2, outputMatchesParsed(output, parsed));
        case 5:
          _context.p = 5;
          _t = _context.v;
          return _context.a(2, false);
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _creatingOutputExists.apply(this, arguments);
}
function isUtxoSpendable(_x3, _x4) {
  return _isUtxoSpendable.apply(this, arguments);
}
function _isUtxoSpendable() {
  _isUtxoSpendable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, utxokey) {
    var _app$blockchain, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          if (!(typeof (app === null || app === void 0 || (_app$blockchain = app.blockchain) === null || _app$blockchain === void 0 ? void 0 : _app$blockchain.isSlipSpendable) === 'function')) {
            _context2.n = 2;
            break;
          }
          _context2.n = 1;
          return app.blockchain.isSlipSpendable(utxokey);
        case 1:
          _t2 = _context2.v;
          return _context2.a(2, _t2 === true);
        case 2:
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t3 = _context2.v;
          return _context2.a(2, false);
        case 4:
          return _context2.a(2, false);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return _isUtxoSpendable.apply(this, arguments);
}
function publicKeyBase58(app, publicKeyHex) {
  try {
    var _app$crypto;
    if (app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.toBase58) {
      return app.crypto.toBase58(publicKeyHex);
    }
  } catch (err) {
    // keep hex
  }
  return publicKeyHex;
}
function handleRequestUtxo(_x5, _x6) {
  return _handleRequestUtxo.apply(this, arguments);
}
function _handleRequestUtxo() {
  _handleRequestUtxo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, txmsg) {
    var _wasmSlip;
    var params, rawKey, utxokey, parsed, wasmSlip, spendable, hasValue, status;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          params = requestParams(txmsg);
          rawKey = params.utxokey || params.utxo_key || params.key;
          utxokey = normalizeUtxoKeyHex(rawKey);
          if (isUtxoKeyHex(utxokey)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, failure('utxokey required'));
        case 1:
          parsed = parseUtxoKeyHex(utxokey);
          if (parsed) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, success({
            utxokey: utxokey,
            status: 'NOT FOUND',
            slip: null
          }));
        case 2:
          wasmSlip = null;
          try {
            wasmSlip = Slip.fromUtxoKey(utxokey);
          } catch (err) {
            wasmSlip = null;
          }
          _context3.n = 3;
          return isUtxoSpendable(app, utxokey);
        case 3:
          spendable = _context3.v;
          hasValue = parsed.amount > 0n;
          status = 'NOT FOUND';
          if (!spendable) {
            _context3.n = 4;
            break;
          }
          status = 'SPENDABLE';
          _context3.n = 7;
          break;
        case 4:
          if (hasValue) {
            _context3.n = 5;
            break;
          }
          // amount === 0 slips are never inserted into the UTXO hashmap
          status = 'ZERO FEE';
          _context3.n = 7;
          break;
        case 5:
          _context3.n = 6;
          return creatingOutputExists(app, parsed);
        case 6:
          if (!_context3.v) {
            _context3.n = 7;
            break;
          }
          status = 'SPENT';
        case 7:
          return _context3.a(2, success({
            utxokey: utxokey,
            status: status,
            slip: {
              publicKey: ((_wasmSlip = wasmSlip) === null || _wasmSlip === void 0 ? void 0 : _wasmSlip.publicKey) || publicKeyBase58(app, parsed.publicKeyHex),
              publicKeyHex: parsed.publicKeyHex,
              type: parsed.slipTypeName,
              typeId: parsed.slipType,
              blockId: parsed.blockId.toString(),
              transactionId: parsed.txOrdinal.toString(),
              slipIndex: String(parsed.slipIndex),
              amount: parsed.amount.toString()
            }
          }));
      }
    }, _callee3);
  }));
  return _handleRequestUtxo.apply(this, arguments);
}
module.exports = {
  handleRequestUtxo: handleRequestUtxo
};